import React from 'react';
import { connect } from 'react-redux';
import Sb from 'material-ui/Snackbar';
import styles from './styles.scss';

class Snackbar extends React.Component {
  render() {
    return (
      <Sb
        className={styles.materialSnackbar}
        open={this.props.snackbar.open}
        message={this.props.snackbar.message}
        autoHideDuration={2000}
      />
    );
  }
}

export default connect(state => {
  return { snackbar: state.snackbar };
})(Snackbar);



// WEBPACK FOOTER //
// ./src/components/util/snackBar/index.js